import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { isEmpty } from 'lodash-es';
import { BaseBox, DoconLoader } from '@docon/docon-ui-library';
import apiUrls from 'apis/apiUrls';

interface IProps {
  [key: string]: any;
  skipBaseDomain?: boolean;
  src?: string;
  srcDoc?: string;
  data?: any;
  onLoad?: any;
}

function IFrame({ onLoad, data, skipBaseDomain, ...props }: IProps) {
  const iFrameRef = useRef<any>(null);
  const { accessToken } = useSelector((state) => state.auth);
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  useEffect(() => {
    if (!isIframeLoading && !isEmpty(data)) {
      iFrameRef?.current?.contentWindow?.postMessage(data, '*');
    }
  }, [data]);

  function handleLoad() {
    setIsIframeLoading(false);
    // tslint:disable-next-line: no-unused-expression
    onLoad && onLoad({ iFrameRef, ...data });

    if (data) {
      iFrameRef.current.contentWindow.postMessage(data, '*');
    }
  }

  if (props.src && !skipBaseDomain) {
    props.src = `${apiUrls.base}${props.src}&source=reception&tk=${accessToken}`;
  }

  if (!(props.src || props.srcDoc)) { return null; }

  return (
    <>
      {
        isIframeLoading ? <DoconLoader {...props as any} /> : null
      }

      <BaseBox
        as='iframe'
        ref={iFrameRef}
        frameBorder='0'
        width='100%'
        height='100%'
        {...props}
        onLoad={handleLoad}
      />
    </>
  );
}

export default styled(IFrame)``;
